import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotComics from './components/HotComics';
import FeaturedComics from './components/FeaturedComics';
import LatestUpdates from './components/LatestUpdates';
import { getHotComics, getLatestComics, getFeaturedComics } from '@/mocks/comics';

export default function Home() {
  const hotComics = getHotComics(6);
  const featuredComics = getFeaturedComics();
  const latestComics = getLatestComics(8);

  const pageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '洞洞杂货铺漫画 - 在线免费阅读漫画',
    description: '在线免费阅读洞洞杂货铺漫画就选36漫画网，界面简洁、操作便捷，开启沉浸式追漫之旅。',
    url: 'https://36manhua.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '36漫画网',
      url: 'https://36manhua.com',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(pageSchema) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <HotComics comics={hotComics} />
          <FeaturedComics comics={featuredComics} />
          <LatestUpdates comics={latestComics} />

          <section className="py-14 md:py-20 bg-background-950 text-background-200 text-center">
            <div className="max-w-2xl mx-auto px-4 md:px-6">
              <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-4">
                开启你的追漫之旅
              </h2>
              <p className="text-sm text-background-400 mb-8 leading-relaxed">
                每天更新、高清画质、流畅阅读。加入50万+读者的行列，在洞洞杂货铺发现属于你的漫画世界。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="/category/rexue"
                  className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-compass-3-line mr-2"></i>
                  立即探索
                </a>
              </div>
            </div>
          </section>
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}